import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../../app/helpers/debugHelper";
import { resolveAssignmentButtonLabel } from "../../../app/helpers/flowRuleI18nHelper";

const FlowActionButtons = ({ actions = [], disabled = false, onSelectAction, roleKey = '' }) => {
  debugLogPages(':: FlowActionButtons', { actions, disabled, roleKey });
  const { t, i18n } = useTranslation();

  if (!actions.length) {
    return <p className="text-muted small mb-0">{t("general.flow-engine.actions-empty")}</p>;
  }

  return (
    <div className="d-flex flex-wrap gap-2 justify-content-end">
      {actions.map((action) => {
        const label = resolveAssignmentButtonLabel(action, t, i18n, { roleKey });

        return (
          <button
            key={`${action.id}-${action.value}`}
            type="button"
            className="btn btn-sm btn-outline-primary"
            disabled={disabled}
            onClick={() => onSelectAction && onSelectAction(action)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

FlowActionButtons.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.string,
      description: PropTypes.string,
      key_description: PropTypes.string
    })
  ),
  disabled: PropTypes.bool,
  onSelectAction: PropTypes.func,
  roleKey: PropTypes.string
};

export default FlowActionButtons;
